import {createSelector} from 'reselect';
import getShouldHideCard from './getShouldHideCard';
import {getPaymentOptions} from './PaymentOptionSelectors';

export const getHasStoredCard = createSelector(
  [getPaymentOptions, getShouldHideCard],
  (paymentOptions, shouldHideCard) => paymentOptions.some(paymentOption => paymentOption.type === 'STORED_CREDIT_CARD' && !shouldHideCard),
);
